module.exports = __webpack_public_path__ + "static/media/document.9eb9fa93.svg";